import { ProductLocationInventoryPricing } from "@towersystems/roam-common/lib/generated-types";
import Product from "../../../../../../utilities/data/model/Product";
import SaleItem from "../../../../../../utilities/data/model/SaleItem";

export const getObservables = ({ item }: { item: SaleItem }) => {
  return {
    item,
    product: item.product,
  };
};

export function resolveSaleLocationPricing(
  location: any,
  product: Product
): ProductLocationInventoryPricing | undefined {
  const locationPricing = product.locationInventoryPricing.find(
    (i) => i.locationId == location
  );
  return locationPricing ?? product.locationInventoryPricing[0];
}
